export const SET_THREAD_ID = "SET_THREAD_ID";
export const SET_THREAD_MEMBERS = "SET_THREAD_MEMBERS";
export const SET_THREAD_CHATS = "SET_THREAD_CHATS";
export const SET_THREAD_FILTER = "SET_THREAD_FILTER";
export const SET_THREAD_CHAT_SCREEN = "SET_THREAD_CHAT_SCREEN";
export const SET_THREAD_SUBMISSION_DATA = "SET_THREAD_SUBMISSION_DATA";
export const SET_THREAD_ESG_COMPLIANCE_ID = "SET_THREAD_ESG_COMPLIANCE_ID";
